@import (reference) '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';
@import '../../constants/screen-width-breakpoints.module.less';

.rate-viewer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
}

.rate-viewer-body {
  background: @rate-viewer--body--background-color;
  flex: 1;
  overflow: auto;
  position: relative;
  display: flex;
  flex-flow: column nowrap;
}

.rate-viewer-footer {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid @rate-viewer--footer--border-color;
  height: 50px;
  padding: 10px;
  background-color: @rate-browser-modal-form--footer--background-color;
  flex-shrink: 0;

  @media @mobile, @ultramobile {
    position: sticky;
    bottom: 0;
  }
}

.configure-label-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: @space-8;
}

.configure-label-icon {
  height: 16px;
  width: 16px;
}

.all-rates-view-upgrade-banner {
  margin: @space-16 @space-16 0;
}

.carriers-view-upgrade-banner {
  margin: @space-16;
}
